import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { message } from 'antd';
import { DevTool } from '@hookform/devtools';
import { useParams } from 'react-router-dom';

import TextEdit from 'Components/CommonComponents/TextEdit';
import Button from 'Components/CommonComponents/Button/Button';
import Input from 'Components/CommonComponents/ReactHooKForm/Input/Input';
import Progress from 'Components/CommonComponents/Progress';
import AddMultiSearch from 'Components/CommonComponents/JobSection/AddMultiSearch/AddMultiSearch';
import Select from 'Components/CommonComponents/ReactHooKForm/Select/Select';
import { FaStar } from 'react-icons/fa';
import { useClientJobData } from 'ServiceHooks/jobHooks';
import jobService, {
  getAwaitingQuestionnaireJobListings,
} from '../../../Services/JobService';




const JobClient = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset
  } = useForm({
    mode: 'all',
    defaultValues: {
      title: '',
      minimum_experience: '',
      maximum_experience: '',
      minimum_ctc: '',
      maximum_ctc: '',
      notice_period: '',
      required_skill: [],
      preferred_skill: []
    },
  });


  const [jobDescription, setJobDescription] = useState('');
  const [singleSearchOption, setSingleSearchOption] = useState({});
  const [messageApi, messageContextHolder] = message.useMessage();
  const [isProcessing, setProcessing] = useState(false);
  const [checkJobDescriptionError, setCheckJobDescriptionError] = useState(false);
  const [requiredSkills, setRequiredSkills] = useState([]);
  const [preferredSkills, setPreferredSkills] = useState([]);
  const [searchValueToAdd, setSearchvalue] = useState();
  const { token } = useParams();

  const { mutate: sendClientJob } = useClientJobData({
    token: token,
    onSuccess: (data) => {
      messageApi.success('Job data sent successfully!');
    },
    onError: (error) => {
      messageApi.error(error.message || 'Failed to send job data');
    }
  });



  // Search skills from API
  const searchSkills = async (searchValue, fieldCode) => {
    try {
      const response = await jobService.getSearchSkills(
        searchValue,
        'api/v1/jobs/client-job-autosuggestions/skills/', token
      );
      console.log(response, 'response')


      // Properly access the nested results array
      const results = response.data.data?.results || response.data.data || [];

      // Format the response data properly
      const options = results.map(item => ({
        key: item.id.toString(),
        value: item.name || item.option_data,
        label: item.name || item.option_data
      }));
      console.log(options, 'response option')

      setSingleSearchOption(prev => ({
        ...prev,
        [fieldCode]: options
      }));

    } catch (error) {
      console.error('Error searching skills:', error);
      messageApi.error('Failed to search skills');
    }
  };


  const addNewSkill = async (skillName, fieldCode) => {
    await jobService
      .addNewMultiSearchSkill({ value: skillName },
        'api/v1/jobs/client-job-autosuggestions/skills/', token)
      .then((oResposne) => {
        messageApi.open({
          type: 'success',
          content: oResposne.data.data.message,
        });
        searchSkills(skillName, fieldCode);
      })
      .catch((err) => {
        messageApi.open({
          type: 'error',
          content: 'Sorry The Entered item cant be add.',
        });
      });
  };

  // Update your toggleSkillRequirement function
  const toggleSkillRequirement = (skill, makeRequired) => {
    if (makeRequired) {
      // Move from preferred to required
      setPreferredSkills(prev => prev.filter(s => s.key !== skill.key));
      setRequiredSkills(prev =>
        prev.some(s => s.key === skill.key) ? prev : [...prev, skill]
      );
    } else {
      // Move from required to preferred
      setRequiredSkills(prev => prev.filter(s => s.key !== skill.key));
      setPreferredSkills(prev =>
        prev.some(s => s.key === skill.key) ? prev : [...prev, skill]
      );
    }
  };


  const currentSkills = watch('required_skill') || [];
  const currentPreferredSkills = watch('preferred_skill') || [];

  const onSubmit = async (payload) => {
    try {
      setProcessing(true);
      console.log('Submitting job:', payload);
      await sendData(payload);
    } catch (error) {
      messageApi.error(error.message || 'Failed');
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };

  const sendData = async (data) => {
    await sendClientJob(data);
  };


  const onCancel = () => {
    reset(); // Reset all RHF fields
    setJobDescription(''); // Manually reset useState
    setRequiredSkills([]);
    messageApi.info("Form cleared.");
  };


  const handleFormSubmit = (data) => {
    // Validate experience range
    console.log("Form Data:", data);
    if (parseFloat(data.minimum_experience) > parseFloat(data.maximum_experience)) {
      messageApi.open({
        type: 'error',
        content: 'Minimum experience must be less than maximum experience',
      });
      return;
    }

    // Validate CTC range
    if (parseFloat(data.minimum_ctc) > parseFloat(data.maximum_ctc)) {
      messageApi.open({
        type: 'error',
        content: 'Minimum CTC must be less than maximum CTC',
      });
      return;
    }

    // Validate required fields
    if (!jobDescription) {
      setCheckJobDescriptionError(true);
      messageApi.open({
        type: 'error',
        content: 'Job description is required',
      });
      return;
    }

    if (requiredSkills.length === 0) {
      messageApi.open({
        type: 'error',
        content: 'At least one required skill is needed',
      });
      return;
    }

    setProcessing(true);

    const payload = {
      title: data.title,
      description: jobDescription,
      minimum_experience: data.minimum_experience,
      maximum_experience: data.maximum_experience,
      minimum_ctc: data.minimum_ctc,
      maximum_ctc: data.maximum_ctc,
      notice_period: data.notice_period,
      required_skill: requiredSkills.map(skill => skill.key),
      preferred_skill: preferredSkills.map(skill => skill.key),
    };

    onSubmit(payload); // Call internal onSubmit

  };

  const onChangeDescription = (content) => {
    setCheckJobDescriptionError(false);
    setJobDescription(content === '<h2><br></h2>' ? '' : content);
  };


  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm py-4 px-6 border-b">
        <h1 className="text-xl font-semibold text-gray-800">Job Details</h1>
      </header>

      {/* Main Form Content */}
      <main className="flex-1 overflow-auto p-6">
        <form
          onSubmit={handleSubmit(handleFormSubmit)}
          // onSubmit={handleSubmit((data) => console.log("MINIMAL TEST", data))}
          className="max-w-6xl mx-auto bg-white rounded-xl shadow-md p-8 h-full flex flex-col"
        >
          {messageContextHolder}

          <div className="space-y-8 flex-1 overflow-auto">
            {/* Basic Information Section */}
            <section>
              <h2 className="text-lg font-medium text-gray-700 mb-4 pb-2 border-b">Basic Information</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Job Title */}
                <div className="md:col-span-2">
                  <Input
                    name="title"
                    label="Job Title *"
                    control={control}
                    placeholder="e.g. Senior Frontend Developer"
                    rules={{
                      required: 'This field is required',
                      maxLength: {
                        value: 100,
                        message: 'Title should not exceed 100 characters',
                      },
                    }}
                  />
                </div>

                {/* Skills Section */}
                <div className="md:col-span-2">
                  <div className="space-y-2">
                    <AddMultiSearch
                      label="Skills *"
                      placeholder="Search and add skills (e.g. React, Node.js)"
                      options={singleSearchOption.required_skill || []}
                      name="required_skill"
                      control={control}
                      showSearch
                      allowClear
                      searchURL="api/v1/jobs/client-job-autosuggestions/skills/"
                      // onSearch={searchSkills}
                      // onSearch={(value) => searchSkills(value, 'required_skill')}
                      onSearch={(value) => searchSkills(value, 'required_skill')}
                      onClear={() => setValue('required_skill', [])}

                      rules={{
                        validate: () => requiredSkills.length > 0 || 'At least one required skill is needed',
                      }}

                      // Update your onSelect handler
                      onSelect={(skill) => {
                        // Initialize as preferred by default
                        if (!preferredSkills.some(s => s.key === skill.key)) {
                          setPreferredSkills(prev => [...prev, skill]);
                        }
                        setValue('preferred_skill', [...currentPreferredSkills, skill]);
                      }}

                      onDeselect={(skill) => {
                        setRequiredSkills(prev => prev.filter(s => s.key !== skill.key));
                        setPreferredSkills(prev => prev.filter(s => s.key !== skill.key));
                        setValue('required_skill', currentSkills.filter(s => s.key !== skill.key));
                        setValue('preferred_skill', currentPreferredSkills.filter(s => s.key !== skill.key));
                      }}

                      sendAddedData={(skillName) => addNewSkill(skillName, 'required_skill')}
                    />

                    <div className="flex items-center text-sm text-gray-500">
                      <FaStar className="text-yellow-400 mr-1" />
                      <span>Mark skills as required or preferred</span>
                    </div>


                    {/* Required Skills Display */}
                    {requiredSkills.length > 0 && (
                      <div className="mt-4">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Required Skills</h4>
                        <div className="flex flex-wrap gap-2">
                          {requiredSkills.map((skill) => (
                            <div
                              key={`req-${skill.key}`}
                              className="flex items-center gap-2 px-3 py-1 border rounded-full bg-blue-50 border-blue-200"
                            >
                              <span className="text-sm">{skill.value}</span>
                              <FaStar
                                className="cursor-pointer text-yellow-500"
                                onClick={() => toggleSkillRequirement(skill, false)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Preferred Skills Display */}
                    {preferredSkills.length > 0 && (
                      <div className="mt-4">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Preferred Skills</h4>
                        <div className="flex flex-wrap gap-2">
                          {preferredSkills.map((skill) => (
                            <div
                              key={`pref-${skill.key}`}
                              className="flex items-center gap-2 px-3 py-1 border rounded-full bg-gray-50 border-gray-200"
                            >
                              <span className="text-sm">{skill.value}</span>
                              <FaStar
                                className="cursor-pointer text-gray-400 hover:text-gray-500"
                                onClick={() => toggleSkillRequirement(skill, true)}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {errors.required_skill && (
                      <p className="text-red-500 text-sm mt-1">{errors.required_skill.message}</p>
                    )}
                  </div>
                </div>

                {/* Experience Range */}
                <div>
                  <h3 className="text-md font-medium text-gray-700 mb-3">Experience Range *</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <Input
                      name="minimum_experience"
                      label="Minimum (years)"
                      control={control}
                      type="number"
                      step="0.1"
                      min="0"
                      max="50"
                      rules={{
                        required: 'Minimum experience is required',
                        validate: (value) => {
                          const maxExp = getValues('maximum_experience');
                          return !maxExp || parseFloat(value) <= parseFloat(maxExp)
                            || 'Must be ≤ maximum';
                        },
                      }}
                    />

                    <Input
                      name="maximum_experience"
                      label="Maximum (years)"
                      control={control}
                      type="number"
                      step="0.1"
                      min="0"
                      max="50"
                      rules={{
                        required: 'Maximum experience is required',
                        validate: (value) => {
                          const minExp = getValues('minimum_experience');
                          return !minExp || parseFloat(value) >= parseFloat(minExp)
                            || 'Must be ≥ minimum';
                        },
                      }}
                    />
                  </div>
                </div>

                {/* CTC Range */}
                <div>
                  <h3 className="text-md font-medium text-gray-700 mb-3">Salary Range *</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <Input
                      name="minimum_ctc"
                      label="Minimum (₹)"
                      control={control}
                      type="number"
                      min="0"
                      rules={{
                        required: 'Minimum salary is required',
                        validate: (value) => {
                          const maxCtc = getValues('maximum_ctc');
                          return !maxCtc || parseFloat(value) <= parseFloat(maxCtc)
                            || 'Must be ≤ maximum';
                        },
                      }}
                    />

                    <Input
                      name="maximum_ctc"
                      label="Maximum (₹)"
                      control={control}
                      type="number"
                      min="0"
                      rules={{
                        required: 'Maximum salary is required',
                        validate: (value) => {
                          const minCtc = getValues('minimum_ctc');
                          return !minCtc || parseFloat(value) >= parseFloat(minCtc)
                            || 'Must be ≥ minimum';
                        },
                      }}
                    />
                  </div>
                </div>

                {/* Notice Period */}
                <div>
                  <Select
                    name="notice_period"
                    label="Notice Period"
                    control={control}
                    options={[
                      { key: 'immediate', value: 'Immediate' },
                      { key: '15days', value: '15 Days' },
                      { key: '30days', value: '30 Days' },
                      { key: '60days', value: '60 Days' },
                      { key: '90days', value: '90 Days' },
                      { key: 'custom', value: 'Custom' },
                    ]}
                    placeholder="Select notice period"
                  />
                </div>
              </div>
            </section>

            {/* Job Description Section */}
            <section className="flex-1 flex flex-col">
              <h2 className="text-lg font-medium text-gray-700 mb-4 pb-2 border-b">Job Description *</h2>
              <div className="flex-1 flex flex-col">
                <TextEdit
                  onChange={onChangeDescription}
                  initialValue={jobDescription}
                  className="flex-1 min-h-[300px]"
                />
                {checkJobDescriptionError && (
                  <p className="text-red-500 text-sm mt-2">Please provide a job description</p>
                )}
              </div>
            </section>
          </div>

          {/* Form Actions */}
          <footer className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex justify-end space-x-4">
              <Button
                type="button"
                variant="outline"
                onClick={onCancel}
                disabled={isProcessing}
                className="px-6 py-2"
              >
                Cancel
              </Button>

              <Button
                htmlType="submit"
                type="primary"
                loading={isProcessing}
                className="ml-4 text-[#fff] bg-[#0a7f8f]"
              >
                Submit
              </Button>
            </div>
          </footer>
        </form>
      </main>

      {isProcessing && <Progress />}
      <DevTool control={control} />
    </div>
  );
};

export default JobClient;